import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.css']
})
export class AppHeaderComponent implements OnInit {
  @Input() menuitems: MenuItem[];
  @Input() useritems: MenuItem[];
  
  constructor() { }

  ngOnInit() {
  }

}
